import type { ReactNode } from "react";

interface FieldProps {
  label: ReactNode;
  error?: string | null;
  full?: boolean;
  children: ReactNode;
}

// Labeled form field wrapper. When `error` is set, the input gets a red
// border (`.field--invalid`) and the message renders directly below it
// (`.field__error`) instead of a single top-of-form banner.
export const Field = ({ label, error, full, children }: FieldProps) => (
  <label
    className={`field${full ? " field--full" : ""}${error ? " field--invalid" : ""}`}
  >
    {label}
    {children}
    {error ? <span className="field__error">{error}</span> : null}
  </label>
);

export default Field;
